import { createEntitiesSlice } from '~/utils/slices/createEntitiesSlice'

import type { ChatThread } from '../@types'

const useChatThreadEntitiesSlice = createEntitiesSlice<ChatThread>({
  name: 'chatThreadEntitiesSlice',
})

export default useChatThreadEntitiesSlice
